<script>
	import OperationsSection from './OperationsSection.svelte';
	import OperationsSectionContent from './OperationsSectionContent.svelte';
	import "../shared.css";

	export let operations;

	const playOpsTypes = ['accept', 'play', 'control', 'goal', 'support'];
	const nonActionOpsTypes = ['reward', 'resupply', 'clean-up'];
	const tableOpsTypes = ['reaction', 'activation', 'passive'];
	const specialOpsTypes = ['special', 'surprise'];

	let playOps;
	$: playOps = operations.filter((ops) => playOpsTypes.includes(ops.type));
	$: hasPlayOps = playOps.length > 0;

	let nonActionOps;
	$: nonActionOps = operations.filter((ops) => nonActionOpsTypes.includes(ops.type));
	$: hasResupplyOps = nonActionOps.length > 0;

	let tableOps;
	$: tableOps = operations.filter((ops) => tableOpsTypes.includes(ops.type));
	$: hasTableOps = tableOps.length > 0;

	let specialOps;
	$: specialOps = operations.filter((ops) => specialOpsTypes.includes(ops.type));
	$: hasSpecialOps = specialOps.length > 0;

	let endgameOps;
	$: endgameOps = operations.filter((ops) => ops.type === 'endgame');
	$: hasEndgameOps = endgameOps.length > 0;

	let costOp;
	$: costOp = operations.find((op) => op.type === 'cost');
</script>

<div class="container">
	{#if hasPlayOps}
		<OperationsSection type="play" let:labelColor let:textColor>
			<OperationsSectionContent operations={playOps} {labelColor} {textColor} />
		</OperationsSection>
	{/if}
	{#if hasResupplyOps}
		<OperationsSection type="resupply" let:labelColor let:textColor>
			<OperationsSectionContent operations={nonActionOps} {labelColor} {textColor} />
		</OperationsSection>
	{/if}
	{#if hasTableOps}
		<OperationsSection type="table" let:labelColor let:textColor>
			<OperationsSectionContent operations={tableOps} {labelColor} {textColor} />
		</OperationsSection>
	{/if}
	{#if hasSpecialOps}
		<OperationsSection type="special" let:labelColor let:textColor>
			<OperationsSectionContent operations={specialOps} {labelColor} {textColor} />
		</OperationsSection>
	{/if}
	{#if hasEndgameOps}
		<OperationsSection type="endgame" let:labelColor let:textColor>
			<OperationsSectionContent operations={endgameOps} {labelColor} {textColor} />
		</OperationsSection>
	{/if}
	{#if costOp}
		<OperationsSection type="cost" let:labelColor let:textColor>
			<OperationsSectionContent operations={[costOp]} {labelColor} {textColor} />
		</OperationsSection>
	{/if}
</div>

<style>
	.container {
		flex-grow: 1;
		flex-direction: column;
		justify-content: flex-end;
		padding-right: 1.6%;
		gap: calc(var(--height) / 133.6667); /*3px;*/
	}
</style>
